module.exports = __webpack_public_path__ + "static/media/b01.3ae11ce6.png";